export default {
  bankNumber: {
    is: 'Bankanúmer',
    en: 'Bank number',
  },
};
